export function cleanupObsoletedLocalStorageItems() {
  // SSR-safe: invoked at module load from Root.tsx; Node's experimental
  // localStorage exposes the global but its methods are undefined.
  if (typeof window === 'undefined') return
  /**
   * Put no longer used debug keys here
   * Example:
   * localStorage.removeItem('obsoleted-debug-key')
   */

  localStorage.removeItem('growth:dit-model-release-event-dialog-shown')
  localStorage.removeItem('google_one_tap_page_views')
}
